import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { IUserInfoMeResponseDto } from "../../api/interfaces/userInfoMeResponseDto";

type UserInfoMe = IUserInfoMeResponseDto;

interface UserInfoMeState {
  user: UserInfoMe | null;
  setUser: (user: IUserInfoMeResponseDto | null) => void;
  clearUser: () => void;
}

export const useUserInfoMeStore = create<UserInfoMeState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      user: null,
      setUser: (user) =>
        set({
          user,
        }),
      clearUser: () =>
        set({
          user: null,
        }),
    }),
    {
      name: "user-info-me-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
